import React from 'react'
import { makeStyles } from '@mui/styles'

import { Field, InputOption } from '../../types'
import PuiCheckboxList from '../lists/PuiCheckboxList'
import Text from '../Text'

const useStyles = makeStyles(
  theme => ({
    checkbox: {
      padding: 0,
      '& .MuiFormControlLabel-root': {
        marginTop: `${theme.spacing(1)}`,
        display: 'flex',
        alignItems: 'flex-start',
      },
      '& .MuiCheckbox-root': {
        paddingTop: 0,
      },
    },
  }),
  { name: 'ConsentFormMultiSelect' },
)

interface ConsentFormMultiSelectProps {
  readonly disabled?: boolean
  readonly field: Field
  readonly items: InputOption[]
  readonly label: string
  readonly onChange?: (selectedItems: string[]) => void
}

export function ConsentFormMultiSelect({
  field,
  items,
  label,
  onChange,
  ...rest
}: ConsentFormMultiSelectProps) {
  const classes = useStyles()

  const handleChange = (selectedItems: string[]) => {
    field.setValue(selectedItems)
    onChange?.(selectedItems)
  }

  return (
    <>
      <Text>{label}</Text>
      <PuiCheckboxList
        hideAllButton
        className={classes.checkbox}
        initialState={field.initialValue}
        items={items.map(item => ({ id: `${item.id}`, name: item.name }))}
        onChange={handleChange}
        {...rest}
      />
    </>
  )
}
